import React from "react";
import PropTypes from "prop-types";

const Checkbox = (props) => {
	const { label, checked, onChecked, disabled } = props;
	const handleChange = () => {
		if (!disabled) {
			onChecked(!checked);
		}
	};

	return (
		<div className="Checkbox">
			<span className="Checkbox_control" onClick={handleChange}>
				<input type="checkbox" checked={checked} disabled={disabled} onChange={() => {}} />{" "}
				{/* noop onChange to shut up React unneccessary warning */}
				<div className="Checkbox_indicator"></div>
			</span>
			<label className="Checkbox_label" onClick={handleChange}>
				{label}
			</label>
		</div>
	);
};

export default Checkbox;

Checkbox.propTypes = {
	label: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	onChecked: PropTypes.func,
	disabled: PropTypes.bool,
};
